// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2bUZV","overflowing":"ReadFullNote_overflowing__X3w4j"};